// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.imem",
    name: "iMe",
    homepage: "https://imem.app/",
    image_id: "25aa3abf-901b-4d82-bb89-c5ade54c0c00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/ime-messenger/id1450480822",
        android: "https://play.google.com/store/apps/details?id=com.iMe.android",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "wc://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map